import React from 'react'
import ShowCars from '../../buttons/ShowCars'

function CustomerTbody({ customer, index, editCustomer }) {
  return (
    <tr className="border-b border-b-light-gray dark:border-b-gray-700">
      <td
        style={{ borderRight: `2px solid ${customer?.customer_type?.color}` }}
        className="px-6 py-4 dark:text-amber-50"
      >
        {index + 1}
      </td>
      <td className="px-6 py-4 dark:text-amber-50">{customer?.gender}</td>
      <td className="px-6 py-4 dark:text-amber-50">{customer?.full_name}</td>
      <td className={`px-6 py-4 dark:text-amber-50`}>
        <span style={{ color: `${customer?.customer_type?.color}` }}>
          {customer?.customer_type?.value}
        </span>
      </td>
      <td className="px-6 py-4 dark:text-amber-50">{customer?.mobile}</td>
      <td className="px-6 py-4 dark:text-amber-50">
        {customer?.cars?.length > 0 ? (
          <ShowCars editCustomer={editCustomer} customer={customer} />
        ) : (
          <span className={'text-warning'}>- - -</span>
        )}
      </td>
    </tr>
  )
}

export default CustomerTbody
